export default __webpack_public_path__ + "static/apo-blob-mobile-ad5f8c4e71e6aa325c32cd06c6504bf2.png";